import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaCloud, FaBoxes, FaCogs } from 'react-icons/fa'; // Importing React Icons

const ModeSelection = ({setCurrentStep}) => {
  const [selectedMode, setSelectedMode] = useState(null);

  return (
    <motion.div 
      className="flex flex-col items-center justify-start bg-[#191919] text-white px-4"
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      transition={{ duration: 0.5 }}
    >
      <h1 className="text-3xl !text-left font-normal mb-6">Mode Selection</h1>

      {/* Mode Options */}
      <div className="space-y-6 mb-8 w-full max-w-xl">
        <motion.div
          className={`py-4 px-2 border-gray-700 border-b cursor-pointer ${selectedMode === 'simple' ? 'bg-orange-500' : 'bg-[#2a2a2a]'}`}
          onClick={() => {
            setSelectedMode('simple')
            setCurrentStep(3)
          }}
          whileHover={{ scale: 1.05 }}
        >
          <div className="flex items-center gap-4 px-4">
            <FaCloud size={30} className='text-orange-500'/>
            <div>
              <div className="font-semibold">Simple mode</div>
              <p className="text-sm">Easy access to sending, receiving, and basic functionality.</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          className={`py-4 px-2 border-gray-700 border-b cursor-pointer ${selectedMode === 'simple_bootstrap' ? 'bg-orange-500' : 'bg-[#2a2a2a]'}`}
          onClick={() => {
            setSelectedMode('simple_bootstrap')
            setCurrentStep(3)
          }}
          whileHover={{ scale: 1.05 }}
        >
          <div className="flex items-center gap-4 px-4">
            <FaBoxes size={30} className='text-orange-500'/>
            <div>
              <div className="font-semibold">Simple mode (bootstrap)</div>
              <p className="text-sm">Easy access to sending, receiving, and basic functionality. The blockchain is downloaded to your computer.</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          className={`py-4 px-2 border-gray-700 border-b cursor-pointer ${selectedMode === 'advanced' ? 'bg-orange-500' : 'bg-[#2a2a2a]'}`}
          onClick={() => {
            setSelectedMode('advanced')
            setCurrentStep(3)
          }}
          whileHover={{ scale: 1.05 }}
        >
          <div className="flex items-center gap-4 px-4">
            <FaCogs size={30} className='text-orange-500'/>
            <div>
              <div className="font-semibold">Advanced mode</div>
              <p className="text-sm">Includes extra features like mining and message verification. The blockchain is downloaded to your computer.</p>
            </div>
          </div>
        </motion.div>
      </div>
      {/* Back to Menu Button */}
      <motion.button
        onClick={() => setCurrentStep(1)}
        className="mt-4 px-6 py-3 w-full max-w-xl bg-gray-700 rounded text-white"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        Back to menu
      </motion.button>

    </motion.div>
  );
};

export default ModeSelection;
